/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Thunderstorm_HeavyInputs */

const en_ui_weather_thunderstorm_heavy = /** @type {(inputs: Ui_Weather_Thunderstorm_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy thunderstorm`)
};

const de_ui_weather_thunderstorm_heavy = /** @type {(inputs: Ui_Weather_Thunderstorm_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schweres Gewitter`)
};

/**
* | output |
* | --- |
* | "Heavy thunderstorm" |
*
* @param {Ui_Weather_Thunderstorm_HeavyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_thunderstorm_heavy = /** @type {((inputs?: Ui_Weather_Thunderstorm_HeavyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Thunderstorm_HeavyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_thunderstorm_heavy(inputs)
	return de_ui_weather_thunderstorm_heavy(inputs)
});